
import { RevToggle } from '@ds/components/Toggle'
import { IconBattery } from '@ds/icons/IconBattery'
import { parse } from 'query-string'

import { trackClick } from '@tracking/events'

import translations from './NewBattery.translations'
import Arrow from './components/Arrow'
import { ARROW_AVAILABLE_POSITION } from './components/Arrow/Arrow.constants'
import Modal from './components/Modal'

export default {
  components: {
    Arrow,
    IconBattery,
    Modal,
    RevToggle,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    arrowPosition: {
      type: String,
      default: ARROW_AVAILABLE_POSITION.LEFT,
    },
    deviceName: {
      type: String,
      required: true,
    },
    offerType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      animate: false,
    }
  },
  computed: {
    translations: () => translations,

    checked() {
      const hash = parse(this.$route.hash)

      return parseInt(hash?.offerType, 10) === parseInt(this.offerType, 10)
    },

    toggleClassNames() {
      if (this.disabled) {
        return 'border-primary-disabled bg-secondary-disabled'
      }

      if (this.checked) {
        return 'border-primary-active bg-secondary-selected'
      }

      return [
        'border-primary bg-secondary cursor-pointer',
        this.animate && this.$style.container_animation,
      ]
    },

    labelClassNames() {
      if (this.disabled) {
        return 'text-primary-disabled'
      }

      return 'cursor-pointer text-primary'
    },

    iconClassNames() {
      if (this.disabled) {
        return 'border-primary-disabled bg-secondary-hover'
      }

      if (this.checked) {
        return 'border-primary-light bg-success-light'
      }

      return 'border-primary bg-neutral-light'
    },
  },
  methods: {
    onChange(event) {
      this.animate = event.target.checked

      trackClick({
        zone: 'new_battery',
        name: 'new_battery',
        value: event.target.checked ? 'activate' : 'deactivate',
      })

      // Let's update the hash with the right offerType param. Product.vue page component will keep the data fresh
      this.$navigation.push({
        type: 'internal',
        ...this.$route,
        hash: {
          ...parse(this.$route.hash),
          offerType: event.target.checked ? this.offerType : undefined,
        },
      })
    },
  },
}
